import { useMemo } from "react";
import { ApolloProvider } from "@apollo/client";
import { useRouter } from "next/router";
import createClient from "@graphql/create_client";

export default function MyApolloProvider({
  apolloCache,
  children,
  requestId,
  sessionId,
  showError,
}) {
  const router = useRouter();

  function createApolloClient() {
    const origin = process.env.NEXT_PUBLIC_API_HOST
        ? process.env.NEXT_PUBLIC_API_HOST
        : global.window?.location?.origin || "",
      gqlUri = `${origin}${process.env.NEXT_PUBLIC_API_URL || ""}/${router.query.siteId}/d`;

    let apolloClient = global.window?.apolloClient;
    if (!apolloClient) {
      apolloClient = createClient({
        errorHandler: showError,
        extractedCache: apolloCache,
        requestId: requestId,
        sessionId: sessionId,
        siteId: router.query.siteId as string,
        uri: gqlUri,
      });
      if (global.window) global.window.apolloClient = apolloClient;
    }
    return apolloClient;
  }

  const apolloClient = useMemo(() => createApolloClient(), [showError]);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
